import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Sidebar from "./Sidebar";
import LegalFooter from "./LegalFooter";

export default function AppLayout() {
  const { user, companies, activeCompany } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="auth-shell">
        <span className="spinner" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (companies.length === 0) {
    return <Navigate to="/onboarding" replace />;
  }
  // Hard paywall — must have an active subscription (demo accounts bypass server-side)
  if (activeCompany && !activeCompany.subscription_active) {
    return <Navigate to="/subscribe" replace />;
  }
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main">
        <Outlet />
        <LegalFooter />
      </main>
    </div>
  );
}
